import dayjs from "dayjs";
// dayjs.extend(LocalizedFormat)

// 格式化时间戳，毫秒
export function formatTimestamp(time: number): string {
  return dayjs(time).format("DD-MM-YYYY");
}

export function formatTime(time: number): string {
  return dayjs(time).format("HH:mm");
}

/**
 *
 * @param num 金额
 * @returns 格式化货币金额
 */
export const formatNumber = (num: number) => {
  const temp = num || "0";
  return temp.toLocaleString(undefined, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

/**
 * 货币单位格式化
 */
export const formatCurrency = (_currency: string) => {
  const abb: { [key: string]: string } = {
    USD: "$",
    BRL: "R$",
    ARS: "$",
    CLP: "$",
    COP: "$",
    MXN: "MXN",
    PEN: "S/.",
    UYU: "$U",
    ZAR: "R",
    PHP: "₱",
  };
  if (abb[_currency]) {
    return abb[_currency];
  } else {
    return _currency;
  }
};
